export default "__VITE_ASSET__DKDvIOSK__"